import React, { useEffect, useMemo, useState } from "react";
import "./AreaSurvayReport.css";
import GroupCenter from "./GroupCenter";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const AreaSurveyReport = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];

  // const [modalOpen, setModalOpen] = useState(false);
  // const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // console.log("profile",profile)

  const [survayData, setSurvayData] = useState([]);

  // Fetch data when profile loads
  useEffect(() => {
    if (profile?.superAdminId && profile?.branchId && profile?.id) {
      fetchData();
    }
  }, [profile]);

  // console.log("profile data",profile);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `https://narrowitsolution.in/api/get-all-areasurvay?superAdmin=${profile.superAdminId}&branch_id=${profile.branchId}&employee_id=${profile.id}`,
        { headers: { "x-api-key": "hQIJOEokqdWBA76897tJfBKJASB2" } }
      );

      console.log("Survey List:", res.data.data);
      setSurvayData(res.data.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ------------------------------------
      SEARCH + PAGINATION
  ------------------------------------ */
  const filteredData = useMemo(() => {
    return survayData.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [survayData, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div className="area-survay-container">
        <h1 className="area-survay-heading">Area Survey Report</h1>

        {/* Filter div */}
        <div className="area-survay-report-filter-div">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="area-survay-filter">
            <label>Show </label>
            <select
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              value={itemsPerPage}
            >
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        {/* Table */}
        <div className="area-survay-report-table-container">
          <table className="area-survay-report-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Branch</th>
                <th>Survey Start Date</th>
                <th>Employee</th>
                <th>Area Name</th>
                <th>Village Name</th>
                <th>Population</th>
                <th>Political Situation</th>
                <th>MFI Name</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.branch || "--"}</td>
                    <td>
                      {new Date(item.surveyDate).toLocaleDateString("en-IN")}
                    </td>
                    <td>{item.employee || "--"}</td>
                    <td>{item.areaName}</td>
                    <td>{item.villageName}</td>
                    <td>{item.populationOfVillage}</td>
                    <td>{item.politicalSituation}</td>
                    <td>{item.mfiNames}</td>
                    <td>{item.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  {loading ? (
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  ) : (
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="area-survay-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default AreaSurveyReport;
